// Author THQ
// Date 2025-04-09 11:18:49

class PpeApplyScrap {
constructor({
        id = null,
        workOrderCode = '',
        status = '',
        applyIdDept = '',
        applicant = '',
        applicantName = '',
        ehsManager = '',
        warehouseKeeper = '',
        applyType = '',
        applyReason = '',
        remark = '',
        applyStartDate = '',
        applyEndDate = '',
        attachments = '',
        attachmentsList = ''}
= {}) {
    this.id = id;
    this.workOrderCode = workOrderCode;
    this.status = status;
    this.applyIdDept = applyIdDept;
    this.applicant = applicant;
    this.applicantName = applicantName;
    this.ehsManager = ehsManager;
    this.warehouseKeeper = warehouseKeeper;
    this.applyType = applyType;
    this.applyReason = applyReason;
    this.remark = remark;
    this.applyStartDate = applyStartDate;
    this.applyEndDate = applyEndDate;
    this.attachments = attachments;
    this.attachmentsList = attachmentsList;
}
}

function newEntity() {
return new PpeApplyScrap();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.ppe.ppeApplyScrap.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'workOrderCode',
        label: 'label.em.ppe.ppeApplyScrap.grid.workOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'status',
        label: 'label.em.ppe.ppeApplyScrap.grid.status',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'statusName',
        label: 'label.em.ppe.ppeApplyScrap.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyIdDept',
        label: 'label.em.ppe.ppeApplyScrap.grid.applyIdDept',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyDeptName',
        label: 'label.em.ppe.ppeApplyScrap.grid.applyDeptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applicantNumber',
        label: 'label.em.ppe.ppeApplyScrap.grid.applicantNumber',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applicantName',
        label: 'label.em.ppe.ppeApplyScrap.grid.applicantName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ehsManagerNumber',
        label: 'label.em.ppe.ppeApplyScrap.grid.ehsManagerNumber',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'ehsManagerName',
        label: 'label.em.ppe.ppeApplyScrap.grid.ehsManagerName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehouseKeeperNumber',
        label: 'label.em.ppe.ppeApplyScrap.grid.warehouseKeeperNumber',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'warehouseKeeperName',
        label: 'label.em.ppe.ppeApplyScrap.grid.warehouseKeeperName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyStartDate',
        label: 'label.em.ppe.ppeApplyScrap.grid.applyStartDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'applyEndDate',
        label: 'label.em.ppe.ppeApplyScrap.grid.applyEndDate',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'attachmentsList',
        label: 'label.em.ppe.ppeApplyScrap.grid.attachmentsList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
                        }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeApplyScrap.grid.remark',
        sortable: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                        }
        },
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    workOrderCodeFilter : '',
    statusFilter : '',
    applyIdDeptFilter : '',
    applyDeptNameFilter : '',
    applicantFilter : '',
    applicantNameFilter : '',
    ehsManagerFilter : '',
    warehouseKeeperFilter : '',
    applyReasonFilter : '',
    applyStartDateRteFilter : '',
    applyStartDateLteFilter : '',
    applyEndDateRteFilter : '',
    applyEndDateLteFilter : '',
    workflowQueryTypeFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'workOrderCodeFilter',
        label: 'label.em.ppe.ppeApplyScrap.filter.workOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.ppe.ppeApplyScrap.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'PpeApplyScrap',statusFilter:1}
        }
        },
        {
        key: 'applyDeptNameFilter',
        label: 'label.em.ppe.ppeApplyScrap.filter.applyDeptName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applicantNameFilter',
        label: 'label.em.ppe.ppeApplyScrap.filter.applicantName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyStartDateRteFilter',
        label: 'label.em.ppe.ppeApplyScrap.filter.applyStartDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyStartDateLteFilter',
        label: 'label.em.ppe.ppeApplyScrap.filter.applyStartDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyEndDateRteFilter',
        label: 'label.em.ppe.ppeApplyScrap.filter.applyEndDateRte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'applyEndDateLteFilter',
        label: 'label.em.ppe.ppeApplyScrap.filter.applyEndDateLte',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
];


    const entityFormConfigs = [
        {
        key: 'applicant',
        label: 'label.em.ppe.ppeApplyScrap.entity.applicant',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,required: true
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"applicantName":"name","applyIdDept":"deptId"}'
                }
        },
        {
        key: 'applicantName',
        label: 'label.em.ppe.ppeApplyScrap.entity.applicantName',
        sortable: true,
        disabled: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.em.ppe.ppeApplyScrap.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentsList',
        label: 'label.em.ppe.ppeApplyScrap.entity.attachments',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachments'
                }
        }
]

export {PpeApplyScrap, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
